<script setup>
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import {ref, watch} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useStore} from "vuex";
import Swal from "sweetalert2";
import router from "@/router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {Line} from 'vue-chartjs'
import {Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend} from 'chart.js'
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

import {Swiper, SwiperSlide} from 'swiper/vue';


ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)


document.body.scrollTop = 0
document.documentElement.scrollTop = 0

let chartData = ref({
  labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
  datasets: [
    {
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      label: "آمار فروش",
      borderColor: "rgba(75, 192, 192, 1)",
      backgroundColor: "rgba(75, 192, 192, 1)",
      tension: 0.4, // انحنای خط
    },
    {
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      label: "آمار خدمات",
      borderColor: "rgb(213,48,48)",
      backgroundColor: "rgb(246,7,2)",
      tension: 0.4, // انحنای خط
    }
  ]
})

let chartOptions = ref({
  responsive: true,
  scales: {
    y: {
      beginAtZero: true,
      min: 10, // کمترین مقدار محور Y
      max: 100, // بیشترین مقدار محور Y
      ticks: {
        stepSize: 10, // فاصله مقادیر
      },
    },
    x: {
      ticks: {
        font: {
          family: "iransans", // فونت برای محور X
          size: 12,
        },
      },
    },
  },
  plugins: {
    title: {
      display: true,
      text: "نمودار سال",
      font: {
        family: "iransans", // نام فونت دلخواه
        size: 16, // اندازه فونت
        weight: "bold", // ضخامت فونت
      },
    },
    legend: {
      labels: {
        font: {
          family: "IRANSans", // فونت برای لیبل‌های راهنما
          size: 12,
        },
      },
    },
  },
});

let chartRef = ref(null);

let store = useStore()

store.commit('set_filter_products', 'delete')
store.commit('set_filter_products_store', 'delete')
store.commit('set_comparison_products', null)

let pics = ref([])

let products = ref([])
let excutives = ref([])
let adver = ref([])
let notif = ref([])
let app_message = null

let my_profile = ref(store.state.my_profile)

let cities = ref([])
let sub_cats = ref([])
let check_orders = store.state.check_orders

let place = ref({
  state: null,
  city: null
})

let page_alert = ref('state')

let country = ref([])

let loading = ref(false)

let dialog = ref(false)

let show_app_message = ref(false)

watch(() => dialog.value, () => {

  if (dialog.value == false) {
    setTimeout(() => {
      page_alert.value = 'state'
    }, 500)
  }

})

let input_search = ref('')

function search_products() {
  if (input_search.value.trim().length === 0) return false

  router.push({name: 'SearchBy', params: {word: input_search.value}})
}

async function get_country() {

  if (country.value.length > 0) {
    dialog.value = true
    return false
  }

  loading.value = true

  await FreeWorld.Heisenberg({}, 'user/city').then((res) => {

    loading.value = false
    country.value = res.data.results
    dialog.value = true

  }).catch((result) => {
    loading.value = false
    Swals.Catch(result, get_country)
  })
}

async function load_home() {

  loading.value = true

  await FreeWorld.Heisenberg({}, 'home_page', true).then((result) => {

    let res = result.data
    products.value = res.products
    excutives.value = res.excutives
    adver.value = res.adver
    pics.value = res.slider

    app_message = res.app_message
    notif.value = res.notif

    sub_cats.value = res.sub_cat

  }).catch((result) => {
    loading.value = false
    Swals.Catch(result, load_home)
  })


  await FreeWorld.Heisenberg({}, 'chart').then((res) => {

    loading.value = false

    chartOptions.value.plugins.title.text = res.data.title_year

    chartData.value = {
      ...chartData.value, // سایر مقادیر اصلی را حفظ کنید
      datasets: [
        {
          ...chartData.value.datasets[0],
          data: res.data.forosh, // مقادیر جدید
        },
        {
          ...chartData.value.datasets[1],
          data: res.data.khadamat, // مقادیر جدید
        },
      ],
    };

    chartRef.value.chart.update();

  }).catch((result) => {
    loading.value = false
    Swals.Catch(result, load_home)
  })


  setTimeout(async () => {

    if (notif.value[0] && check_orders) {

      await Swal.fire({
        title: "تایید نهایی تکمیل سفارش",
        text: "محصول و سفارش" + notif.value[0].ord_num + "با رضایت و سلامت کامل کالا , دریافت گردید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
        confirmButtonText: "تایید نهایی",
        cancelButtonText: "هنوز دریافت نکردم",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          router.push({name: 'CommentOrders', params: {ord_id: notif.value[0].id}})
        }
        if (result.isDismissed) {
          store.commit('set_check_orders', false)
        }
      });

    }

    if (app_message && store.state.message) show_app_message.value = true

  }, 2000)


  // setTimeout(()=>{
  // show_header(true)
  // },100)

}

load_home()

// let h
//
// function show_header(action) {
//
//   let header = document.getElementById('header');
//   let hr = document.getElementById('hr_poster');
//
//   if (action) {
//     header.style.height = 'auto'
//     setTimeout(() => {
//       show_header()
//     }, 500)
//   } else {
//
//     // اگر اولین بار است که تابع فراخوانی می‌شود و ارتفاع هنوز تنظیم نشده باشد
//     if (header.style.height != '7.5rem') {
//       h = header.offsetHeight.toString() + 'px';
//     }
//
//     if (header.style.height !== h) {
//       header.style.height = h;
//       hr.style.width = '60%';
//     } else {
//       header.style.height = '7.5rem';
//       hr.style.width = '30%';
//     }
//
//   }
// }

async function alert_country(action, id) {

  if (action === 'state') {

    if (id === -1) {
      place.value.state = id
      place.value.city = id
      dialog.value = false
      set_user()
      return false
    }

    place.value.state = id
    country.value.forEach((item) => {
      if (id == item.id) {
        cities.value = item.city
      }
    })
    // $("#alert_state").addClass('animate__animated animate__fadeOut')
    page_alert.value = 'city'

  } else {
    place.value.city = id
    dialog.value = false
    set_user()
  }

}

function slider_link(item) {
  if (item.url.includes('StorePage')) {
    let sid = item.url.split('/').pop();

    router.push({name: 'StorePage', params: {unit_id: sid}})
  } else {
    window.open(item.url, '_blank');
  }
}

function set_user() {

  loading.value = true

  let data = {
    action: 'search',
    search_state: place.value.state,
    search_city: place.value.city,
  }

  FreeWorld.Heisenberg(data, 'user_edit', true).then((result) => {

    loading.value = false
    let res = result.data
    if (res.event === "update ok") {

      my_profile.value.search_state = place.value.state
      my_profile.value.search_city = place.value.city
      store.commit('set_my_profile', my_profile.value)
      place.value = {
        state: null,
        city: null
      }

      load_home()

    } else {

      Swal.fire({
        position: "center",
        icon: "error",
        title: "متاسفانه لوکیشن شما ویرایش نشد",
        showConfirmButton: true,
        confirmButtonText: 'متوجه شدم',
        allowOutsideClick: false,
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      })

    }

  }).catch((result) => {
    loading.value = false
    Swals.Catch(result, set_user)
  })

}

const txtoverflow = document.querySelectorAll('.txtoverflow');

function startAnimation() {
  txtoverflow.forEach(element => {
    element.classList.add('animate');
  });
}

function stopAnimation() {
  txtoverflow.forEach(element => {
    element.classList.remove('animate');
  });
}

txtoverflow.forEach(element => {
  element.addEventListener('animationstart', startAnimation);
  element.addEventListener('animationend', stopAnimation);
});


</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <v-dialog v-model="show_app_message" max-width="500">
    <template v-slot:default="">
      <v-card title="">
        <template v-slot:item>
          <p dir="rtl" class="font-4 font-normal" v-html="app_message"></p>
        </template>

        <div class="d-flex justify-content-center w-100 my-4">
          <v-btn
              class="bg-color text-white font-5 font-bold"
              text="دیگه نشون نده"
              variant="flat"
              @click="store.commit('set_message', false) ; show_app_message = false"
          ></v-btn>
        </div>
      </v-card>
    </template>
  </v-dialog>

  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        scrollable
        width="auto"
        height="40rem">

      <v-card class="rounded-4">
        <v-card-title class="font-3 text-center mt-2">انتخاب شهر و استان خود</v-card-title>
        <v-divider></v-divider>

        <v-card-text v-if="page_alert == 'state' " id="alert_state" style="height: 300px;">

          <v-btn-group class="w-100 mb-2 rounded-4">
            <v-btn :active="my_profile.search_state == -1" @click="alert_country('state' , -1)"
                   class="w-100 font-4 bg-main">همه استان ها
            </v-btn>
          </v-btn-group>

          <v-btn-group class="w-100 mb-2 rounded-4" v-for="item in country" :key="item.id">
            <v-btn :active="my_profile.search_state == item.id" @click="alert_country('state' , item.id)"
                   class="w-100 font-4 bg-main">{{ item.name }}
            </v-btn>
          </v-btn-group>

        </v-card-text>

        <v-card-text v-else id="alert_city" class="" style="height: 300px;">

          <v-btn-group class="w-100 mb-2 rounded-4">
            <v-btn :active="my_profile.search_city == -1" @click="alert_country('city' , -1)"
                   class="w-100 font-4 bg-main">همه شهر ها
            </v-btn>
          </v-btn-group>

          <v-btn-group class="w-100 mb-2 rounded-4" v-for="item in cities" :key="item.id">
            <v-btn :active="my_profile.search_city == item.id" @click="alert_country('city' , item.id)"
                   class="w-100 font-4 bg-main">{{ item.name }}
            </v-btn>
          </v-btn-group>

        </v-card-text>

        <v-divider></v-divider>


      </v-card>
    </v-dialog>
  </v-row>


  <div style="overflow: unset" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

    <div class="pt-2 position-fixed p-3 top-0 w-100 max_width bg-color rounded-bottom-5 z-3">

      <div class="d-flex justify-content-between align-items-center mb-3">
        <a href="https://decoban.ir/assets/app/Decoban.apk" class="m-0 text-decoration-none font-5 font-bold text-center p-3 w-45 bg-white font-color rounded-5">دانلود اپلیکیشن دکوبان</a>

        <a href="https://decoban.ir/assets/app/DecobanShop.apk" class="m-0 text-decoration-none font-5 font-bold text-center p-3 w-45 bg-white font-color rounded-5">دانلود اپلیکیشن دکوشاپ</a>
      </div>

      <div class="d-flex align-items-center rounded-bottom-5 justify-content-between flex-row-reverse max_width w-100 z-3 bg-color">
        <img @click="get_country" class="icon_location_home" src="../assets/img/location_home_icon.svg" alt=""
             loading="lazy">

        <div class="div_search text-decoration-none text-black">
          <input v-model="input_search" @keydown.enter="search_products"
                 class="input_search bg-white text-center font-4 rounded-4" placeholder="جستجوی محصولات">
          <img class="icon_search center-y" src="../assets/img/search_icon.svg" alt="">
        </div>
      </div>
    </div>

    <div id="header" class="header_homePage rounded-bottom-5 bg-color p-body">

      <div v-if="pics.length > 0" class="mt-3">

        <swiper
            :slides-per-view="1.1"
            :slides-per-group="1"
            :space-between="5"
            :pagination="true"
            :centeredSlides="true"
            :autoplay="{ delay: 2000, disableOnInteraction: false }"
        >

          <swiper-slide dir="rtl" class="" v-for="(item , index) in pics" :key="index">
            <img @click="slider_link(item)" class="w-100 div_slider rounded-4" :src="item.pic" alt="">
          </swiper-slide>

        </swiper>

      </div>

      <div v-if="sub_cats.length > 0" class="mt-3">

        <swiper
            :slides-per-view="3.2"
            :slides-per-group="3"
            :space-between="10"
            :autoplay="{ delay: 2000, disableOnInteraction: false }"
        >

          <swiper-slide dir="rtl" class="" v-for="item in sub_cats" :key="item.id">

            <router-link :to="{name:'ProductsStore' , params:{sub_cat_id:item.id , name:item.name}}"
                         class="categories rounded-3 text-decoration-none text-black d-flex flex-column align-items-center justify-content-between shadow-sm">

              <div class="animated-background rounded-2 img_categories ">
                <img v-if="item.pic == null " class="w-100 rounded-2 m-auto d-block"
                     src="../assets/img/img-notavalible.jpg" alt="">
                <img v-else class="w-100 h-100 rounded-2 m-auto d-block" :src="item.pic" alt="">
              </div>

              <p class="font-5 text-center" :class="{'txtoverflow':item.name.length > 10}">{{ item.name }}</p>
            </router-link>

          </swiper-slide>

        </swiper>

      </div>

    </div>

    <br>

    <div class="d-flex p-body mb-3">
      <img style="width: 1.8rem;margin-left: 10px" src="../assets/img/top_icon.svg" alt="">
      <p class="font-3 font-bold font-color">
        دسته بندی خدمات دکوبان
      </p>
    </div>

    <div class="list_Service d-flex justify-content-between align-items-center p-body">
      <router-link to="ProductsCategory"
                   class="Service_categories d-flex flex-column align-items-center justify-content-between p-2 rounded-4 bg-white text-decoration-none">
        <img class="" src="../assets/Gifts/shop.gif" alt="">

        <p class="font-4 font-bold text-center mt-2">
          فروشگاه
        </p>
      </router-link>

      <router-link to="ExecutivesCategory"
                   class="Service_categories d-flex flex-column align-items-center justify-content-between p-2 rounded-4 text-decoration-none bg-white">
        <img class="" src="../assets/Gifts/mojry.gif" alt="">

        <p class="font-4 font-bold text-center mt-2">
          مجریان
        </p>
      </router-link>

      <router-link to="JobSearchCategory"
                   class="Service_categories d-flex flex-column align-items-center justify-content-between p-2 rounded-4 text-decoration-none bg-white">
        <img class="" src="../assets/Gifts/karyabi.gif" alt="">

        <p class="font-4 font-bold text-center mt-2">
          کاریابی
        </p>
      </router-link>
    </div>

    <br>

    <div v-if="products.length > 0" class="mb-2 p-body mb-3">

      <div class="d-flex align-items-center mb-3">
        <img style="width: 1.8rem;margin-left: 10px" src="../assets/img/top_icon.svg" alt="">
        <p class="font-3 font-color font-bold">
          پرفروش ترین محصولات
        </p>
      </div>
      <!--****  محصولات تخفیفی  ***-->

      <swiper
          :slides-per-view="1.2"
          :slides-per-group="1"
          :space-between="10"
          :autoplay="{ delay: 2000, disableOnInteraction: false }"
          :centeredSlides="true"
      >

        <swiper-slide dir="rtl" class="bg-white rounded-shaped" v-for="item in products" :key="item.id">

          <router-link :to="{name:'DetailsProducts' , params:{prod_id:item.id , sub_cat_id:item.sub_categoris}}"
                       class="p-3 products_custom_off text-decoration-none text-black shadow-sm d-flex justify-content-between">

            <div class="position-relative ml-1 rounded-4">

              <img v-if="item.pic1 == null " class="img_products_off rounded-4"
                   src="../assets/img/img-notavalible.jpg" alt="">
              <img v-else class="img_products_off rounded-4" :src="item.pic1" alt="">

              <div class="div_stars rounded-pill p-1 d-flex position-absolute shadow">
                <p class="font-5 text-center">{{ item.rating_product }}</p>
                <img style="width:1.5rem" src="../assets/img/star_gold.svg" alt="">
              </div>

            </div>

            <div style="width: calc(100% - 10rem);"
                 class="position-relative d-flex flex-column justify-content-around pr-2">

              <p class="off_percent top-0 p-1 font-4 rounded-pill font-color">
                <span>%</span>
                <span>{{ item.discount }}</span>
              </p>
              <div class="overflow-hidden text-right w-75">
                <p class="font-4 font-bold " :class="{'txtoverflow':item.name.length >= 15}">{{ item.name }}</p>
              </div>

              <div class="">

                <p class="font-4 text-right"
                   :class="item.off_price == null ? 'font-color' : 'text-decoration-line-through' ">
                  <span>{{ item.price.toLocaleString() }}</span>
                  <span v-if="item.off_price == null">تومان</span>
                </p>

                <p v-if="item.off_price != null" class="font-5 font-color text-right">
                  <span>{{ item.off_price.toLocaleString() }}</span>
                  <span>تومان</span>
                </p>

              </div>

              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <img style="width: 1.2rem" src="../assets/img/shop.svg" alt="">
                  <div class="overflow-hidden d-flex align-items-center">
                    <p class="font-4 mr-1" :class="{'txtoverflow':item.unit_name.length >= 20}">{{ item.unit_name }}</p>
                  </div>
                </div>
                <div v-if="item.rating_store != null && item.rating_store > 0 " class="position-relative">
                  <img style="width: 1.8rem;" src="../assets/img/star_gold.svg" alt="">
                  <p style="left: 52%;top: 52%; transform: translate(-50% , -50%)"
                     class="position-absolute font-5 text-white">{{ item.rating_store }}</p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <img style="width: 1.2rem" src="../assets/img/list.svg" alt="">
                <p v-if="item.brand != null" class="font-4 mr-1" :class="{'txtoverflow':item.brand.length > 15}">
                  {{ item.brand }}</p>
                <p v-else class="font-5 mr-1">مشخص نشده</p>
              </div>
            </div>
          </router-link>

        </swiper-slide>

      </swiper>

    </div>

    <br>

    <!--    ***بنر تبلیغاتی***-->
    <div class="p-body mb-5">
      <router-link to="EducationCategory" class="baner">
        <img class="img_baner rounded-4" src="../assets/Gifts/amozesh.gif" alt="">
      </router-link>
    </div>

    <div class="">
      <div class="d-flex p-body mb-3">
        <img style="width: 1.8rem;margin-left: 10px" src="../assets/img/top_icon.svg" alt="">
        <p class="font-3 font-bold font-color">
          وبلاگ دکوبان
        </p>
      </div>

      <div class="p-body">
        <router-link :to="{name:'WebPage'}" class="">
          <img class="img_baner rounded-4" src="../assets/img/BLOG.jpg" alt="">
        </router-link>
      </div>
    </div>

    <div v-if="excutives.length > 0">

      <br>
      <br>

      <div class="d-flex p-body mb-3">
        <img style="width: 25px;margin-left: 10px" src="../assets/img/top_icon.svg" alt="">
        <p class="font-3 font-bold font-color">
          برترین مجریان
        </p>
      </div>

      <div class="list_products p-body">

        <router-link v-for="item in excutives" :key="item.id"
                     :to="{name:'DetailsExecutives' , params:{prof_id: item.id}}"
                     class="rounded-shaped products_custom shadow-sm text-decoration-none text-black d-flex justify-content-between">

          <div class="animated-background ml-2 rounded-4">

            <img v-if="item.profile_pic == null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg"
                 alt="">
            <img v-else class="img_products rounded-4" :src="item.profile_pic" alt="">

          </div>

          <div style="width: calc(100% - 9.5rem);"
               class="position-relative d-flex flex-column justify-content-between position-relative">

            <img v-if="item.active_profile" class="position-absolute top-0 start-0" src="../assets/img/active_user.png"
                 alt="">

            <p class="font-3 font-bold my-2 w-85">{{ item.name }}</p>

            <p v-if="item.active_business" class="font-5 font-bold my-2 font-color-red w-85">دارای پروانه کسب</p>

            <p class="font-4">
              <span>{{ item.state }}</span>
              _
              <span>{{ item.city }}</span>
            </p>
          </div>

        </router-link>

      </div>

    </div>

    <div v-if="adver.length > 0">

      <br>
      <br>

      <div class="d-flex p-body mb-3">
        <img style="width: 25px;margin-left: 10px" src="../assets/img/new_icon.svg" alt="">
        <p class="font-3 font-bold font-color">
          آخرین آگهی های کاریابی
        </p>
      </div>

      <div class="list_products p-body">

        <router-link v-for="item in adver" :key="item.id" :to="{name:'DetailsAdvertising' , params:{adver_id:item.id}}"
                     class="rounded-shaped products_custom text-decoration-none text-black shadow-sm d-flex justify-content-between">

          <div class="animated-background rounded-4">

            <img v-if="item.pic == null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
            <img v-else class="img_products rounded-4" :src="item.pic" alt="">

          </div>

          <div style="width: calc(100% - 9.5rem);" class="position-relative d-flex flex-column justify-content-between">

            <p class="font-3 font-bold my-2">{{ item.adver_name }}</p>

            <div class="">
              <p class="font-4 my-1">{{ item.time }}</p>
              <p class="font-4">
                <span>{{ item.state }}</span>
                _
                <span>{{ item.city }}</span>
              </p>
            </div>

          </div>
        </router-link>

      </div>

    </div>

    <br><br>

    <div class="p-body position-relative">
      <Line
          ref="chartRef"
          id="my-chart-id"
          :options="chartOptions"
          :data="chartData"
      />
    </div>

    <br><br><br>

    <BottomNavigation class="position-fixed bottom-0"></BottomNavigation>
  </div>

  <div style="overflow: unset" id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>
    <br>

    <div style="height: 28rem" class="d-flex mb-5 px-4" :class="pics.length > 0 ? 'justify-space-between' : 'justify-center'">
      <div class="d-flex flex-column h-100 justify-content-center align-items-center bg-color w-30"
           :class="pics.length > 0 ? 'w-50' : 'rounded-5 w-80'">
        <p class="font-6 text-white mb-15 px-3">به خانواده بزرگ دکوبان خوش آمدید
          سوپر اپلیکیشن دکوبان در زمینه فروش کالا
          و ارائه خدمات مشاوره ای و کاریابی در این زمینه است.
          با خدمات ما همراه باشید.
        </p>

        <a href="https://decoban.ir/assets/app/Decoban.apk" target="_blank"
           class="bg-white font-color font-bold p-2 shadow rounded-pill font-6 text-center w-75 text-decoration-none">دانلود
          اپلیکیشن</a>
        <a href="https://decoban.ir/assets/app/DecobanShop.apk" target="_blank"
           class="bg-white font-color my-3 font-bold p-2 shadow rounded-pill font-6 text-center w-75 text-decoration-none">دانلود
          اپلیکیشن فروشگاه</a>
        <a href="https://shop.decoban.ir" target="_blank"
           class="bg-white font-color font-bold p-2 shadow rounded-pill font-6 w-75 text-center text-decoration-none">ورود به وب
          اپلیکیشن فروشگاه</a>
      </div>

      <div v-if="pics.length > 0" class="h-100 w-70">

        <swiper
            :slides-per-view="1"
            :slides-per-group="1"
            :space-between="5"
            :pagination="true"
            :autoplay="{ delay: 2000, disableOnInteraction: false }"
            :centeredSlides="true"
        >

          <swiper-slide dir="rtl" class="" v-for="item in pics" :key="item.id">

            <img @click="slider_link(item)" style="height: 28rem" class="w-100" :src="item.pic" alt="">

          </swiper-slide>

        </swiper>

      </div>
    </div>

    <div class="d-flex p-body mb-4">
      <img style="width: 25px;margin-left: 10px" src="../assets/img/top_icon.svg" alt="">
      <p class="font-3 font-bold font-color">
        دسته بندی های فروشگاه
      </p>
    </div>

    <div style="height: 13rem" v-if="sub_cats.length > 0" class="px-3 mb-5">

      <swiper
          :slides-per-view="8.2"
          :slides-per-group="8"
          :space-between="10"
          :navigation="true"
          :autoplay="{ delay: 2000, disableOnInteraction: false }"
      >

        <swiper-slide dir="rtl" class="categorie_web" v-for="item in sub_cats" :key="item.id">

          <router-link :to="{name:'ProductsStore' , params:{sub_cat_id:item.id , name:item.name}}"
                       class="animate__animated animate__fadeIn w-100 h-100 p-2 rounded-3 text-decoration-none text-black d-flex flex-column align-items-center justify-content-between shadow-sm">

            <div class="animated-background rounded-2 w-100 h-80 mb-2">
              <img v-if="item.pic == null " class="w-100 h-100 rounded-2 m-auto d-block"
                   src="../assets/img/img-notavalible.jpg" alt="">
              <img v-else class="w-100 h-100 rounded-2 img-cover m-auto d-block" :src="item.pic" alt="" loading="lazy">
            </div>

            <p class="font-5 text-center" :class="{'txtoverflow':item.name.length >= 15}">{{ item.name }}</p>
          </router-link>

        </swiper-slide>

      </swiper>

    </div>

    <div id="Services" class="d-flex p-body mb-4">
      <img style="width: 25px;margin-left: 10px" src="../assets/img/top_icon.svg" alt="">
      <p class="font-3 font-bold font-color">
        دسته بندی خدمات دکوبان
      </p>
    </div>

    <!--    ***بنر تبلیغاتی***-->
    <div class="d-flex justify-content-between align-items-center">
      <div class="w-45 m-auto">
        <router-link style="height: 20rem" to="EducationCategory" class="animate__animated animate__fadeIn">
          <img class="w-100 h-100 shadow rounded-4" src="../assets/img/EDUCATION.jpg" alt="">
        </router-link>
      </div>

      <div class="w-45 m-auto">
        <router-link style="height: 20rem" to="EducationCategory" class="animate__animated animate__fadeIn">
          <img class="w-100 h-100 shadow rounded-4" src="../assets/img/BLOG.jpg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>

    <div class="d-flex justify-content-around align-items-center p-body">
      <router-link to="ProductsCategory"
                   class="animate__animated animate__fadeIn shadow item_category d-flex flex-column justify-content-center align-items-center p-2 rounded-4 bg-white text-decoration-none">
        <img style="width: 75%" class="mb-7 d-block" src="../assets/Gifts/shop.gif" alt="">

        <p class="font-3 font-bold text-center">
          فروشگاه
        </p>
      </router-link>

      <router-link to="ExecutivesCategory"
                   class="animate__animated animate__fadeIn shadow item_category d-flex flex-column justify-content-center align-items-center p-2 rounded-4 text-decoration-none bg-white">
        <img style="width: 75%" class="mb-7 d-block" src="../assets/Gifts/mojry.gif" alt="">
        <p class="font-3 font-bold text-center">
          مجریان
        </p>
      </router-link>

      <router-link to="JobSearchCategory"
                   class="animate__animated animate__fadeIn shadow item_category d-flex flex-column justify-content-center align-items-center p-2 rounded-4 text-decoration-none bg-white">
        <img style="width: 75%" class="mb-7 d-block" src="../assets/Gifts/karyabi.gif" alt="">
        <p class="font-3 font-bold text-center">
          کاریابی
        </p>
      </router-link>
    </div>

    <br>
    <br>
    <br>

    <div class="d-flex p-body mb-4">
      <img style="width: 25px;margin-left: 10px" src="../assets/img/top_icon.svg" alt="">
      <p class="font-3 font-bold font-color">
        پرفروش ترین محصولات دکوبان
      </p>
    </div>

    <div v-if="products.length > 0" class="px-8">

      <swiper
          :slides-per-view="4.1"
          :slides-per-group="4"
          :space-between="10"
          :navigation="true"
          :autoplay="{ delay: 2000, disableOnInteraction: false }"
      >

        <swiper-slide dir="rtl" class="h-100 bg-white rounded-shaped products_custom_off" v-for="item in products" :key="item.id">

          <router-link :to="{name:'DetailsProducts' , params:{prod_id:item.id , sub_cat_id:item.sub_categoris}}"
                       class="shadow p-2 text-decoration-none text-black shadow-sm d-flex justify-content-between">

            <div class="img_products_web position-relative rounded-4">

              <img v-if="item.pic1 == null " class="w-100 h-100 img-cover rounded-4"
                   src="../assets/img/img-notavalible.jpg" loading="lazy" alt="">
              <img v-else class="w-100 h-100 img-cover rounded-4" :src="item.pic1" alt="">

              <div class="div_stars shadow rounded-pill d-flex position-absolute">
                <p class="font-4 text-center">{{ item.rating_product }}</p>
                <img style="width:15px" src="../assets/img/star_gold.svg" alt="">
              </div>

            </div>

            <div style="width: calc(100% - 7.3em)"
                 class="position-relative d-flex flex-column justify-content-around">

              <p class="off_percent top-0 p-1 font-6 rounded-pill font-color">
                <span>%</span>
                <span>{{ item.discount }}</span>
              </p>

              <div class="overflow-hidden text-right w-80 ml-2">
                <p class="font-6 font-bold " :class="{'txtoverflow':item.name.length > 20}">{{ item.name }}</p>
              </div>

              <div class="">

                <p class="text-right font-6"
                   :class="item.off_price == null ? 'font-color' : 'text-decoration-line-through' ">
                  <span>{{ item.price.toLocaleString() }}</span>
                  <span v-if="item.off_price == null" class="mr-1">تومان</span>
                </p>

                <p v-if="item.off_price != null" class="font-6 font-color text-right">
                  <span>{{ item.off_price.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>

              </div>

              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <img style="width: 1rem" src="../assets/img/shop.svg" alt="">
                  <div class="overflow-hidden d-flex align-items-center">
                    <p class="font-6 mr-1" :class="{'txtoverflow':item.unit_name.length >= 20}">{{ item.unit_name }}</p>
                  </div>
                </div>

                <div v-if="item.rating_store != null && item.rating_store > 0 " class="position-relative">
                  <img style="width: 1rem" src="../assets/img/star_gold.svg" alt="">
                  <p style="left: 50%;top: 55%; transform: translate(-50% , -50%)"
                     class="position-absolute font-6 text-white">{{ item.rating_store }}</p>
                </div>
              </div>

              <div class="d-flex align-items-center">
                <img style="width: 1rem" src="../assets/img/list.svg" alt="">
                <p v-if="item.brand != null" class="font-6 mr-1" :class="{'txtoverflow':item.brand.length > 15}">
                  {{ item.brand }}</p>
                <p v-else class="font-6 mr-1">مشخص نشده</p>
              </div>
            </div>
          </router-link>

        </swiper-slide>

      </swiper>

    </div>

    <br>
    <br>
    <br>

    <div style="height: 25rem"
         class="w-90 ma-auto shadow d-flex justify-space-between align-items-center bg-white rounded-4 mb-5">
      <img class="w-50 h-100 " src="../assets/img/baner.svg" alt="">

      <div class="d-flex flex-column h-100 justify-content-center align-items-center bg-white p-5 w-50">
        <p class="font-3 font-bold text-center mb-4">به خانواده بزرگ دکوبان خوش آمدید</p>

        <p class="font-3 text-center mb-4 px-">سوپر اپلیکیشن دکوبان، در زمینه فروش کالا
          و ارائه خدمات مشاوره ای و کاریابی در این زمینه است.
          با خدمات ما همراه باشید.
        </p>

        <p class="font-3 text-center mb-4 px-16">میتونی در دکوبان فروشنده بشی و کالاهات را به
          جامعه آماری بالای کاربران معرفی کنی
        </p>
      </div>
    </div>

    <div v-if="adver.length > 0">

      <br>
      <br>

      <div class="d-flex p-body mb-10">
        <img style="width: 25px;margin-left: 10px" src="../assets/img/new_icon.svg" alt="">
        <p class="font-bold font-color">
          آخرین آگهی های کاریابی
        </p>
      </div>

      <div class="p-body">

        <swiper
            :slides-per-view="4.2"
            :slides-per-group="4"
            :space-between="5"
            :navigation="true"
        >

          <swiper-slide dir="rtl" class="products_custom_web" v-for="item in adver" :key="item.id">

            <router-link :to="{name:'DetailsAdvertising' , params:{adver_id:item.id}}"
                         class="shadow bg-white rounded-shaped p-2 text-decoration-none text-black shadow-sm d-flex justify-content-between">

              <div style="width: 7em; height: 7em" class="animated-background rounded-4">
                <img v-if="item.pic == null " class="w-100 h-100 img-cover rounded-4"
                     src="../assets/img/img-notavalible.jpg" alt="">
                <img v-else class="w-100 h-100 img-cover rounded-4" :src="item.pic" alt="">
              </div>

              <div style="height: 7rem;width: calc(100% - 7.3rem)" class="position-relative d-flex flex-column justify-content-between overflow-hidden">

                <p class="font-6 font-bold my-2" :class="{'txtoverflow':item.adver_name.length >= 20}">{{ item.adver_name }}</p>

                <div class="">
                  <p class="font-6 my-1">{{ item.time }}</p>
                  <p class="font-6">
                    <span>{{ item.state }}</span>
                    _
                    <span>{{ item.city }}</span>
                  </p>
                </div>

              </div>
            </router-link>

          </swiper-slide>

        </swiper>

      </div>

    </div>

    <div v-if="excutives.length > 0">

      <br>
      <br>

      <div class="d-flex p-body mb-4">
        <img style="width: 25px;margin-left: 10px" src="../assets/img/top_icon.svg" alt="">
        <p class="font-bold font-color">
          برترین مجریان
        </p>
      </div>

      <div class=" p-body">

        <swiper
            :slides-per-view="4.2"
            :slides-per-group="4"
            :space-between="5"
            :navigation="true"
        >

          <swiper-slide dir="rtl" class="products_custom_web" v-for="item in excutives" :key="item.id">

            <router-link :to="{name:'DetailsExecutives' , params:{prof_id: item.id}}"
                         class="shadow bg-white p-2 rounded-shaped shadow-sm text-decoration-none text-black d-flex justify-content-between">

              <div style="height: 7rem;width: 7rem" class="animated-background rounded-4">
                <img v-if="item.profile_pic == null " class="w-100 img-cover h-100 rounded-4"
                     src="../assets/img/img-notavalible.jpg" alt="">
                <img v-else class="w-100 h-100 img-cover rounded-4" :src="item.profile_pic" alt="">
              </div>

              <div class="position-relative details_items d-flex flex-column justify-content-between overflow-hidden">

                <p class="font-6 font-bold my-2" :class="{'txtoverflow':item.name.length >= 20}">{{ item.name }}</p>

                <p v-if="item.active_business" class="font-7 font-bold my-2 font-color-red w-85">دارای پروانه کسب</p>

                <p class="font-7">
                  <span>{{ item.state }}</span>
                  _
                  <span>{{ item.city }}</span>
                </p>

              </div>

            </router-link>

          </swiper-slide>

        </swiper>

      </div>

    </div>

    <br><br>

    <div style="max-height: 30rem" class="p-body d-flex justify-content-center position-relative">
      <Line
          ref="chartRef"
          id="my-chart-id"
          :options="chartOptions"
          :data="chartData"
      />
    </div>

    <FooterPage></FooterPage>

  </div>

</template>

<style scoped>

@media (min-width: 750px) {
  .Service_categories {
    width: 11rem !important;
    height: 11rem !important;
  }

  .Service_categories > img {
    width: 7rem !important;
  }
}

.img_products_web{
  width: 7rem;
  height: 7rem;
}

.details_items{
  width: calc(100% - 7.3rem)
}

.header_homePage {
  padding-top: 13rem;
  width: 100%;
  box-shadow: 0 0 20px;
  max-width: 1200px;
  padding-bottom: 2rem;
  z-index: 1;
  overflow: hidden;
  transition: 0.5s;
}

p {
  margin: 0;
}

.div_search {
  width: 80%;
  position: relative;
}

.hr_poster {
  width: 60%;
  height: 6px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.71);
  position: absolute;
  bottom: 15px;
  transition: 0.5s;
}

.input_search {
  width: 100%;
  height: 55px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon_location_home {
  width: 4.6rem;
}

.icon_search {
  height: 2rem;
  position: absolute;
  left: 1rem;
}

.list_categories {
  width: 100%;
  display: flex;
  overflow-x: scroll;
}

.list_categories::-webkit-scrollbar {
  display: none;
}

.list_products::-webkit-scrollbar {
  display: none;
}

.categories {
  min-width: 8rem;
  height: 9rem;
  background-color: white;
  overflow: hidden;
  padding: .6rem;
}

.categorie_web {
  min-width: 9rem;
  width: 9rem;
  height: 11rem;
  background-color: white;
  overflow: hidden;
}

.list_products {
  width: 100%;
  height: 150px;
  display: flex;
  overflow-x: scroll;
}

.list_products_web {
  width: 100%;
  display: flex;
  overflow-x: scroll;
}

.products_custom {
  padding: .8rem;
  width: 25rem;
  min-width: 25rem;
  background-color: white;
  margin-left: .8rem;
  height: 10.5rem;
}

.products_custom_web {
  width: 23em;
  height: 100%;
}

.products_custom_off {
  border-radius: 15px;
  width: 100%;
  height: 100%;
  min-width: 17rem;
}

.img_products {
  width: 9rem;
  height: 9rem;
}

.img_products_off {
  width: 10rem;
  height: 10rem;
}

.div_stars {
  min-width: 40%;
  right: 50%;
  transform: translate(50%, 0);
  bottom: -.5rem;
  background-color: white;
  justify-content: space-evenly;
}

.off_percent {
  position: absolute;
  left: 0;
  text-align: center;
  background-color: #d2d2d2;
}

.list_Service {
  display: flex;
  width: 100%;
}

.Service_categories {
  width: 9.5rem;
  height: 11rem;
}

.Service_categories > img {
  width: 90%;
}

.baner {
  width: 100%;
  height: 200px;
}

.img_baner {
  width: 100%;
  height: 160px;
}

.alert {
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(77, 81, 84, 0.76);
  z-index: 3;
  max-width: 700px;
  display: flex;
  align-items: center;
}

.item_category {
  width: 15rem;
  height: 15rem;
}

.div_slider {
  height: 15rem !important;
}

.img_categories {
  width: 100%;
  height: 80%;
  margin: 0 auto;
}

</style>